module.exports = __webpack_public_path__ + "static/media/Location pin.53cedbd5.svg";